import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { SymptomIntialValues, SymptomValidationSchema } from "../../constant";
import {
  useMutateCreateSymptom,
} from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import InputWithLabel from "../../../../Components/InputWithLabel";

import { Switch } from "../../../../Components";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";

const AddSymptom = () => {
  const navigate = useNavigate();
  const addSymptomApi = useMutateCreateSymptom();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitAddSymptom = (values) => {
    const reqData = {
      name: values?.name,
      isOnboarded: values?.isOnboarded,
    };

    setIsLoading(true);
    addSymptomApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || "Added Successful.");
        navigate("/admin/symptom");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };
  return (
    <>
      <Helmet>
        <title>OVE | Admin Add Symptom</title>
      </Helmet>
      <div className="symptom-page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card symptom-card-border overflow-visible">
                <div className="symptom-card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Add Symptom</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/symptom" />
                      </div>
                    </div>
                  </div>

                  <Formik
                    initialValues={SymptomIntialValues}
                    validationSchema={SymptomValidationSchema}
                    validateOnChange
                    onSubmit={handleSubmitAddSymptom}
                  >
                    {(formik) => {
                      const { setFieldValue, setFieldTouched, values } = formik;
                      return (
                        <Form>
                          <section className="symptom-section-border">
                            <div className="row">
                              <div className="col-md-6">
                                <Field
                                  Label="Name"
                                  type="text"
                                  name="name"
                                  placeholder="Enter Symptom Name"
                                  component={InputWithLabel}
                                />
                              </div>

                              <div className="form-group col-md-6">
                                <label className="d-block">Is Onboarded</label>
                                <div className="switch-handler">
                                  <Switch
                                    name="isOnboarded"
                                    checked={values.isOnboarded}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "isOnboarded",
                                        e.target.checked
                                      );
                                    }}
                                    color="primary"
                                    size="medium"
                                  />
                                </div>
                                <ErrorMessage
                                  name="isOnboarded"
                                  component="span"
                                  className="error d-block"
                                />
                              </div>
                            </div>
                            <SaveButton loading={isLoading} />
                          </section>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSymptom;
